module.exports = __webpack_public_path__ + "static/media/noun_Arrow_1256499.6159bc13.svg";